import { getRequest } from "./performanceApiClient";

export const getOverview = async (params = {}) =>
  getRequest("/analytics/overview", { params });

export const getGoalCompletion = async () =>
  getRequest("/analytics/goal-completion");

export const getDepartmentPerformance = async () =>
  getRequest("/analytics/department-performance");

export const getTopPerformers = async (params = {}) =>
  getRequest("/analytics/top-performers", { params });

export const getRatingDistribution = async () =>
  getRequest("/analytics/rating-distribution");

export const getFeedbackTrends = async () =>
  getRequest("/analytics/feedback-trends");

export const getReviewCompletion = async () =>
  getRequest("/analytics/review-completion");

export const getCompetencyDistribution = async (params = {}) =>
  getRequest("/analytics/competency-distribution", { params });

export const getCampaignCompletion = async () =>
  getRequest("/analytics/campaign-completion");

export const getRelationWiseRatingSpread = async (params = {}) =>
  getRequest("/analytics/relation-wise-rating-spread", { params });

export default {
  getOverview,
  getGoalCompletion,
  getDepartmentPerformance,
  getTopPerformers,
  getRatingDistribution,
  getFeedbackTrends,
  getReviewCompletion,
  getCompetencyDistribution,
  getCampaignCompletion,
  getRelationWiseRatingSpread,
};
